import React, { useEffect } from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';
import Markdown from "react-markdown";
import rehypeRaw from 'rehype-raw';
import Footer from './Footer';
import postlist from '../posts.json';

const customComponents = {
  // Personaliza el renderizado de un elemento h2
  h2: ({ node, children, ...props }) => (
    <h2 className='text-center md:text-start' style={{ fontSize: '26px', paddingBottom: '1.5rem' }} {...props}>
      {children}
    </h2>
  ),

  // Personaliza el renderizado de un elemento h3
  h3: ({ node, children, ...props }) => (
    <h3 className='text-center md:text-start' style={{ fontSize: '22px', paddingTop: '1rem', paddingBottom: '1.5rem' }} {...props}>
      {children}
    </h3>
  ),

  // Personaliza el renderizado de un elemento h3
  h4: ({ node, children, ...props }) => (
    <h4 className='text-center md:text-start' style={{ fontSize: '20px', paddingTop: '1rem', paddingBottom: '1.5rem' }} {...props}>
      {children}
    </h4>
  ),
  // Personaliza el renderizado de un elemento p
  p: ({ node, children, ...props }) => (
    <p className='text-center md:text-start' style={{ fontSize: '18px', lineHeight: '1.5', paddingBottom: '1rem' }} {...props}>
      {children}
    </p>
  ),

};


const ArtistaLayout = () => {
  useEffect(() => {
    // Ajusta la posición de la ventana al principio de la carga
    window.scrollTo(0, 0);
  }, []);
  const { id } = useParams();
  console.log('ID from useParams:', id);

  let validId;

  // Verifica si id es una cadena no vacía antes de intentar convertirla a un número
  if (id && !isNaN(id)) {
    validId = parseInt(id);
  }

  // Busca el post con el id correspondiente en postlist
  const post = postlist.find(post => post.id === validId);

  // Si el post no se encuentra, redirige a la página 404
  if (!post) {
    return <Navigate to='/404' />;
  }

  const fetchedPost = {};
  let postExists = false

  postlist.forEach((post, i) => {
    if (validId === post.id) {
      fetchedPost.title = post.title ? post.title : " Titulo no encontrado"
      fetchedPost.image = post.image ? post.image : " Imagen no encontrada"
      fetchedPost.description = post.description ? post.description : " Descripcion no encontrada"
      fetchedPost.content = post.content ? post.content : " Contenido no encontrado"
      postExists = true
    }
  })
  if (!postExists) {
    return <Navigate to="/404" />
  }
  console.log(fetchedPost.image)

  return (
    <div>
      <motion.div
        variants={fadeIn('up', 0.3)}
        initial="hidden"
        whileInView={"show"}
        id='artistalayout' className='container lg:pt-14 mx-auto pb-10'
      >
        <h1 className='text-5xl text-secondary pb-8 text-center md:text-start'>{fetchedPost.title}</h1>
        <div className='py-5 flex justify-center'>
          {fetchedPost.image && <img src={`/ImgArtistas/${fetchedPost.image}`} alt={`imagen de ${fetchedPost.title}`} className='img-fluid' />}
        </div>
        <br />
        <Markdown rehypePlugins={[rehypeRaw]} components={customComponents}>
          {fetchedPost.content.replace(
            /<iframe/g,
            '<iframe style="display: block; margin: auto; max-width: 80%; width: 100%"'
          )}
        </Markdown>
      </motion.div>
      <motion.div
        variants={fadeIn('up', 0.3)}
        initial="hidden"
        whileInView={"show"}
        className='flex justify-center items-center mb-12 mx-auto lg:mx-0'>
        <Link to='../artistas'
          activeclass='active'
          smooth={true}
          spy={true}
          offset={-10}
        >
          <button className='btn btn-sm text-primary text-lg'>Volver al listado de artistas</button>
        </Link>
      </motion.div>
      <Footer />
    </div>
  );
};

export default ArtistaLayout;
